import { Component, ElementRef, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { DialogService } from 'src/app/service/dialog/dialog.service';
declare var $: any;

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DialogComponent implements OnInit, OnDestroy {
  @Input() id: string;
  @Input() record: any;

  element: HTMLElement;

  constructor(
    private dialogService: DialogService,
    private el: ElementRef,
  ) {
    this.element = this.el.nativeElement;
  }

  ngOnInit(): void {
    if (!this.id) {
      console.error('`id` is required for dialog components');
      return;
    }

    document.body.appendChild(this.element);
    this.dialogService.add(this);
  }

  ngOnDestroy(): void {
    this.dialogService.remove(this.id);
    this.element.remove();
  }

  open(): Promise<any> {
    $(`#${this.element.id}_modal`).modal();
    return new Promise(resolve => {
      $(`#${this.element.id}_btn-ok`).on('click', () => {
        $(`#${this.element.id}_btn-ok`).prop('onclick', null).off('click');
        $(`#${this.element.id}_modal`).modal('hide');
        $(`#${this.element.id}_modal`).off('hidden.bs.modal');
        return resolve(true);
      });

      $(`#${this.element.id}_modal`).on('hidden.bs.modal', () => {
        $(`#${this.element.id}_btn-ok`).prop('onclick', null).off('click');
        $(`#${this.element.id}_modal`).off('hidden.bs.modal');
        return resolve(false);
      });
    });
  }

  close(): void { }
}
